import { render } from "./BoardWithoutGroup.vue?vue&type=template&id=2274f81a&scoped=true"
import script from "./BoardWithoutGroup.vue?vue&type=script&lang=js"
export * from "./BoardWithoutGroup.vue?vue&type=script&lang=js"

import "./BoardWithoutGroup.vue?vue&type=style&index=0&id=2274f81a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2274f81a"]])

export default __exports__